module.exports = function getResource(label, vars = []) {
    const resources = {
        userLabelText: `You must be ${vars[0]} to access this product.`,
        signIn: 'Sign in',
        or: 'or',
        signUp: 'Sign up',
        learnMore: 'Learn more',
        download: 'Download',
        openApp: 'open the Sephora app to purchase.',
        bopisTooltip: 'Scroll down and tap “Buy Online & Pick Up” to get your beauty today.'
    };
    return resources[label];
};
